module.exports = __webpack_public_path__ + "static/media/changelog.7730e513.md";